import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Link, withRouter} from 'react-router-dom'
import {Modal, Button} from 'antd'

import style from './modal.sass'

@withRouter
@inject('store') @observer
class UpgradeModal extends Component {
  handleCancel = () => {
    this.props.store.permissions.hideModal()
  }
  goBack = () => {
    this.props.history.goBack()
    this.handleCancel()
  }
  render() {
    let {modal, modalText, buttonLink, buttonText, closeable} = this.props.store.permissions
    if (!buttonLink) {
      buttonLink = '/upgrade'
    }
    return(
      <Modal
        styleName='modal'
        visible={modal}
        closeable={false}
        footer={[
          <Link key='continue' to={buttonLink}><Button type='button' styleName='upgrade'>{buttonText}</Button></Link>,
          <Button key='back' onClick={closeable ? this.handleCancel : this.goBack} styleName='cancel'>Cancel</Button>
        ]}
      >
        <h3>{modalText}</h3>
      </Modal>
    )
  }
}

export default UpgradeModal
